import makeItemLookup from './utils/makeItemLookup';
import convertOperations from './utils/convertOperations';
import makeItemFilter from './utils/makeItemFilter';
import { generateExpressions } from './expressions';
import { generateCoverPanels } from './coverpanels';
import { generateEdges } from './edges';
import { sinkTypes } from './sinks';
import { generateWallEdgingStrip, generateWallEdgingStripCustomizable } from './splashbacks';

import messages from './messages/materialMessages';

export const NO_WORKTOP_MATERIAL = 'noMaterial';

export const noWorktop = {
  id: NO_WORKTOP_MATERIAL,
  displayName: messages[NO_WORKTOP_MATERIAL],
};

export function generateMaterials(businessRules, items, thicknesses, country, language) {
  const { materials, edges: allowedEdges, expressions } = businessRules;
  const itemLookup = makeItemLookup(items);

  const woodExpressions = makeItemFilter(expressions.wood);
  const lightExpressions = makeItemFilter(expressions.light);
  const darkExpressions = makeItemFilter(expressions.dark);

  const sinkType = (itemsWithSameDesign) => {
    let type = '';

    itemsWithSameDesign.some((item) => {
      if (woodExpressions(item)) {
        type = sinkTypes.wood;
        return true;
      }

      if (lightExpressions(item)) {
        type = sinkTypes.light;
        return true;
      }

      if (darkExpressions(item)) {
        type = sinkTypes.dark;
        return true;
      }

      return false;
    });

    return type;
  };
  const firstAvailableMaterial = materials.map(({ id, edges = [], operations = {}, useDecentralizedSinkOptions = false }) => ({
    id,
    displayName: messages[id] || { id: `cwt.materials.${id}` },
    expressions: generateExpressions(id, businessRules, items, thicknesses, sinkType, country, language),
    edges: generateEdges(id, edges, allowedEdges, itemLookup),
    operations: convertOperations(operations, itemLookup),
    wallEdgingStrip: generateWallEdgingStrip(id, businessRules, items),
    wallEdgingStripCustomizable: generateWallEdgingStripCustomizable(id, businessRules, items),
    decentralizedSinkOptions: useDecentralizedSinkOptions,
    coverpanels: generateCoverPanels(id, businessRules, items, thicknesses, sinkType, country, language),
  })).find((material) => {
    if (material.expressions.length === 0) {
      return false;
    }
    if(material.edges === 'noEdgeIncluded'){
      return true;
    }
    if (material.edges.length === 0) {
      return false;
    }
    return true;
  });
  let noMaterial;
  if (firstAvailableMaterial) {
    noMaterial = ({
      id: noWorktop.id,
      displayName: messages[NO_WORKTOP_MATERIAL],
      expressions: firstAvailableMaterial.expressions,
      edges: firstAvailableMaterial.edges,
      operations: firstAvailableMaterial.operations,
      wallEdgingStrip: firstAvailableMaterial.wallEdgingStrip,
      decentralizedSinkOptions: firstAvailableMaterial.useDecentralizedSinkOptions ? firstAvailableMaterial.useDecentralizedSinkOptions : false,
      coverpanels: firstAvailableMaterial.coverpanels,
    });
    return [noMaterial].concat(materials.map(({ id, edges = [], operations = {}, useDecentralizedSinkOptions = false }) => ({
      id,
      displayName: messages[id] || { id: `cwt.materials.${id}` },
      expressions: generateExpressions(id, businessRules, items, thicknesses, sinkType, country, language),
      edges: generateEdges(id, edges, allowedEdges, itemLookup),
      operations: convertOperations(operations, itemLookup),
      wallEdgingStrip: generateWallEdgingStrip(id, businessRules, items),
      wallEdgingStripCustomizable: generateWallEdgingStripCustomizable(id, businessRules, items),
      decentralizedSinkOptions: useDecentralizedSinkOptions,
      coverpanels: generateCoverPanels(id, businessRules, items, thicknesses, sinkType, country, language),
    })).filter((material) => {
      if (material.expressions.length === 0) {
        // eslint-disable-next-line no-console
        console.error('Excluding material:', material.id, 'due to no expressions');
        return false;
      }
      if(material.edges === 'noEdgeIncluded'){
        return true;
      }
      if (material.edges.length === 0) {
        // eslint-disable-next-line no-console
        console.error('Excluding material:', material.id, 'due to no edges');
        return false;
      }
      return true;
    }));
  } else {
    return materials.map(({ id, edges = [], operations = {}, useDecentralizedSinkOptions = false }) => ({
      id,
      displayName: messages[id] || { id: `cwt.materials.${id}` },
      expressions: generateExpressions(id, businessRules, items, thicknesses, sinkType),
      edges: generateEdges(id, edges, allowedEdges, itemLookup),
      operations: convertOperations(operations, itemLookup),
      wallEdgingStrip: generateWallEdgingStrip(id, businessRules, items),
      wallEdgingStripCustomizable: generateWallEdgingStripCustomizable(id, businessRules, items),
      decentralizedSinkOptions: useDecentralizedSinkOptions,
      coverpanels: generateCoverPanels(id, businessRules, items, thicknesses, sinkType, country, language),
    })).filter((material) => {
      if (material.expressions.length === 0) {
        // eslint-disable-next-line no-console
        console.error('Excluding material:', material.id, 'due to no expressions');
        return false;
      }
      if (material.edges.length === 0) {
        // eslint-disable-next-line no-console
        console.error('Excluding material:', material.id, 'due to no edges');
        return false;
      }
      return true;
    });
  }
}
